import { render, staticRenderFns } from "./Reassing.vue?vue&type=template&id=2cea17ba&scoped=true"
import script from "./Reassing.vue?vue&type=script&lang=js"
export * from "./Reassing.vue?vue&type=script&lang=js"
import style0 from "./Reassing.vue?vue&type=style&index=0&id=2cea17ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cea17ba",
  null
  
)

export default component.exports